import { render, staticRenderFns } from "./LinkableCell.vue?vue&type=template&id=8f0d7ff6&scoped=true"
import script from "./LinkableCell.vue?vue&type=script&lang=js"
export * from "./LinkableCell.vue?vue&type=script&lang=js"
import style0 from "./LinkableCell.vue?vue&type=style&index=0&id=8f0d7ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0d7ff6",
  null
  
)

export default component.exports